var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 21C6.45006 21 5.97923 20.8042 5.58756 20.4125C5.19589 20.0208 5.00006 19.55 5.00006 19V6C4.71673 6 4.47923 5.90417 4.28756 5.7125C4.09589 5.52083 4.00006 5.28333 4.00006 5C4.00006 4.71667 4.09589 4.47917 4.28756 4.2875C4.47923 4.09583 4.71673 4 5.00006 4H9.00006C9.00006 3.71667 9.09589 3.47917 9.28756 3.2875C9.47923 3.09583 9.71673 3 10.0001 3H14.0001C14.2834 3 14.5209 3.09583 14.7126 3.2875C14.9042 3.47917 15.0001 3.71667 15.0001 4H19.0001C19.2834 4 19.5209 4.09583 19.7126 4.2875C19.9042 4.47917 20.0001 4.71667 20.0001 5C20.0001 5.28333 19.9042 5.52083 19.7126 5.7125C19.5209 5.90417 19.2834 6 19.0001 6V19C19.0001 19.55 18.8042 20.0208 18.4126 20.4125C18.0209 20.8042 17.5501 21 17.0001 21H7.00006ZM17.0001 6H7.00006V19H17.0001V6ZM9.00006 17H11.0001V8H9.00006V17ZM13.0001 17H15.0001V8H13.0001V17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.5d30dcae7e2f8e37143d38321a769394.svg";
export { ForwardRef as ReactComponent };